module.exports = __webpack_public_path__ + "img/bar.7de18221.svg";